var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2992 17.0002H12.6992V9.80019H10.2992V17.0002ZM11.4992 5.0002C10.8992 5.0002 10.2992 5.60019 10.2992 6.20019C10.2992 6.80019 10.8992 7.4002 11.4992 7.4002C12.0992 7.4002 12.6992 6.80019 12.6992 6.20019C12.6992 5.60019 12.0992 5.0002 11.4992 5.0002ZM11.4992 0.200195C5.49922 0.200195 0.699219 5.0002 0.699219 11.0002C0.699219 17.0002 5.49922 21.8002 11.4992 21.8002C17.4992 21.8002 22.2992 17.0002 22.2992 11.0002C22.2992 5.0002 17.4992 0.200195 11.4992 0.200195ZM11.4992 19.4002C6.81922 19.4002 3.09922 15.6802 3.09922 11.0002C3.09922 6.32019 6.81922 2.6002 11.4992 2.6002C16.1792 2.6002 19.8992 6.32019 19.8992 11.0002C19.8992 15.6802 16.1792 19.4002 11.4992 19.4002Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8e8a9861.svg";
export { ForwardRef as ReactComponent };